import { getAriaText } from '@utils/helpers';

export default class JSTickFlashRenderer {
  eGui;
  eCurrent;
  lastValue;
  animationListener;
  params;
  mode;
  noAnimation = false;

  constructor() {
    const template = document.createElement('div');
    template.setAttribute('class', 'c-js-tick-flash');
    const value = document.createElement('div');
    template.appendChild(value);

    this.eGui = template;
    this.eCurrent = value;
  }

  init(params) {
    this.params = params;
    this.setFlashMode();
    this.setAccessibility();

    if (!this.noAnimation) {
      this.animationListener = this.reset.bind(this);
      this.eGui.addEventListener('animationend', this.animationListener);
    }

    const displayedValue = this.getDisplayValue(params);
    if (displayedValue === '-') {
      this.eCurrent.setAttribute('aria-hidden', 'true');
      this.eCurrent.innerHTML = '-';
    }

    this.refresh(params, true);
  }

  getGui() {
    return this.eGui;
  }

  refresh(params) {
    this.params = params;
    if (params.value === this.lastValue) {
      return false;
    }
    const value = this.getDisplayValue(params);
    this.eCurrent.innerText = value;

    if (this.lastValue && this.mode) {
      this.flashColor(params.value, this.lastValue);
    }
    this.lastValue = params.value;
    return true;
  }

  getDisplayValue(params) {
    return params.valueFormatted || params.value;
  }

  setFlashMode() {
    const flashMode = this.params.state.applicationSettings.general.settings.flashDisplay.flashMode;
    switch (flashMode) {
      case 'disabled':
        this.mode = null;
        break;
      case 'textOnly':
        this.mode = 'text';
        break;
      case 'fullCell':
        this.mode = 'cell';
        break;
      case 'noanimation':
        this.mode = 'text';
        this.noAnimation = true;
        break;
    }
  }

  flashColor(newValue, oldValue) {
    newValue = parseFloat(newValue);
    oldValue = parseFloat(oldValue);
    if (!newValue || !oldValue) return;

    if (newValue > oldValue) {
      this.eGui.classList.remove(`${this.mode}-flash-red`);
      this.eGui.classList.add(`${this.mode}-flash-green`);
    } else {
      this.eGui.classList.remove(`${this.mode}-flash-green`);
      this.eGui.classList.add(`${this.mode}-flash-red`);
    }
    if (!this.noAnimation) {
      this.eGui.classList.add('animate');
    }
  }

  reset() {
    this.eGui.classList.remove(`${this.mode}-flash-green`, `${this.mode}-flash-red`, 'animate');
  }

  destroy() {
    if (!this.noAnimation) {
      this.eGui.removeEventListener('animationend', this.animationListener);
      this.animationListener = null;
    }
  }

  setAccessibility() {
    const isAccessible = this.params.state.applicationSettings.accessibility.settings.accessibilityFeatures;
    if (isAccessible) {
      let srElement = document.createElement('span');
      srElement.classList.add('sr-only');
      srElement.innerText = this.getAriaText();
      this.eGui.insertBefore(srElement, this.eCurrent);

      //TODO jsQuoteRenderer should be used in option chain, instead
      //of employing the following if block
      //checking for context is done to determine if it is the option chain.
      if (!this.params.context) {
        let srElement = document.createElement('span');
        srElement.classList.add('sr-only');
        srElement.innerText = this.params.ariaText;
        this.eGui.appendChild(srElement);
      }
    }
    if (this.isSROnly()) {
      this.eCurrent.classList.add('sr-only');
    }
  }

  isSROnly() {
    if (
      !this.params.node.group &&
      this.params.colDef.field === 'q._TRDPRC_1' &&
      this.params.data.index > 0 &&
      this.params.data.strategy === 'MLO'
    ) {
      return true;
    }
    return false;
  }

  getAriaText() {
    if (this.isSROnly()) return this.params.data.allTickerArray.join(', ');
    return getAriaText(this.params);
  }
}
